import { render, staticRenderFns } from "./editSection.vue?vue&type=template&id=626c50f8"
import script from "./editSection.vue?vue&type=script&lang=js"
export * from "./editSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports